import { slideToggle, toggleAria } from "../utils.js";
import "core-js/es/array";

export default class ContentHub {
  constructor() {
    this.contentHub = document.getElementById("content-hub-items");
    this.showMoreBtn = document.getElementById("js-show-more");
    if (this.contentHub && this.showMoreBtn) {
      this.showMoreBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.loadContent();
      });
    }
  }

  makeHTML(
    {
      dateOfEvent,
      dateOfEventFormatted,
      postedDate,
      description,
      endDate,
      endDateFormatted,
      id,
      imageUrl,
      isPromoted,
      tags,
      theme,
      title,
      url,
    },
    byLabel,
    disableColour,
    isNextFeatured,
    addColWidth
  ) {
    var str = `<div data-id="${id}" class="c-ani-no-delay o-flex__col${
      addColWidth ? " o-flex__col--" + (isPromoted ? "8" : "4") : ""
    }${isNextFeatured ? " next" : ""} js-item"><div class="c-lb__item ${
      isPromoted ? "c-lb__item--featured " : ""
    }${
      disableColour ? "c-lb__item--white" : theme
    }"><div class="c-lb__img" style="background-image: url(${imageUrl})"></div><div class="c-lb__content">`;

    str += `<div class="c-tags"><div class="c-tags__items">`;

    if (tags.resource?.name) {
      str += `
					<span class="c-tags__item">

						<svg class="c-tags__icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
							<path d="M0 7.386v-5.98A1.406 1.406 0 011.406 0h5.98a1.406 1.406 0 01.994.412l6.207 6.207a1.406 1.406 0 010 1.989l-5.98 5.98a1.406 1.406 0 01-1.989 0L.412 8.381A1.406 1.406 0 010 7.386zm3.281-5.511a1.406 1.406 0 101.407 1.406 1.406 1.406 0 00-1.407-1.406z"></path>
						</svg>

						<span>${tags.resource.name}</span>

					</span>`;
    }

    str += `</div></div>`;

    str += `<h3 class="c-lb__title"><a class="c-lb__link" href="${url}">${title}</a></h3>`;

    if (description) {
      str += `<p class="c-lb__text">${description}</p>`;
    }

    if (tags.author && tags.author.length) {
      str += `<span class="c-lb__text">`;

      let auth = ``;
      let authCount = 0;
      for (var x = 0; x < tags.author.length; x++) {
        if (authCount > 0) {
          auth += `, `;
        }
        if (tags.author[x].name) {
          auth += `<a class="c-lb__link" href="?author=${tags.author[x].id}#hub">${tags.author[x].name}</a>`;
          authCount++;
        }
      }

      str += byLabel.replace("{0}", auth);

      str += `</span>`;
    }

    if (dateOfEvent) {
      str += `<br><time class="c-lb__text" datetime="${dateOfEventFormatted}">${dateOfEvent}</time>`;
      if (endDate) {
        str += `<time class="c-lb__text" datetime="${endDateFormatted}">${endDate}</time>`;
      }
    }
 

    if(postedDate){
      str += `  <br><time class="c-lb__text" datetime="${postedDate}">${postedDate}</time>`
    }

    str += `</div></div></div>`;

    return str;
  }
  makeHTMLresearch(
    {      
      dateOfEvent,
      dateOfEventFormatted,
      postedDate,
      description,
      wpDescription,
      endDate,
      endDateFormatted,
      id,
      imageUrl,
      isPromoted,
      tags,
      theme,
      title,
      url,
    }
  ){
    var str = `<div data-id="${id}" class="o-flex__col o-flex__col--12 js-item">`;
    str += ` <div class="c-lb__item c-lb__item--white">
    <div class="c-lb__content">
      <h3 class="c-lb__title"><a class="c-lb__link" href="${url}">${title}</a></h3>`;
      if (wpDescription) {
        str += `<span class="c-lb__text">${wpDescription}</span> <br>`;
      }
      str += `<div class="o-flex__col o-flex__col--12 u-right-align">
      <a href="${url}" class="e-btn" type="submit">Read more</a>
       </div>
       <div class="blog-box-bottom">
       <div class="meta-info">`;
       if (tags.author && tags.author.length) {
        let auth = ``;
        for (var x = 0; x < tags.author.length; x++) {
          if (tags.author[x].name) {
            auth += `<div class="blog-author with-icon"> <i class="fas fa-user"></i><a href="?author=${tags.author[x].id}#hub">${tags.author[x].name}</a></div>`;
          }
        }
        str +=  auth;
      }
   
      if (tags.categories && tags.categories.length) {
        str += `<div class="blog-categories">`;
        let categoriesList = ``;
        for (var x = 0; x < tags.categories.length; x++) {
          if (tags.categories[x].name) {
            categoriesList += `  <div class="blog-category with-icon"><i class="fas fa-folder"></i>
            <a href="?category=${tags.categories[x].id}#hub" title="${tags.categories[x].name}">${tags.categories[x].name}</a></div>`;
          }
        }
        str += categoriesList;
        str += `</div>`;
      }
      str +=`  <div class="blog-meta">
      <div class="blog-date with-icon">
          <i class="fas fa-calendar"></i>
          <p>${postedDate}</p>
      </div>                        
     </div>`;

     
    str += `</div></div></div></div></div>`;
    return str;
  }

  loadContent() {
    var items = Array.from(document.querySelectorAll("div.js-item"));
    var exclusionIds = items.map((val) => {
      return val.dataset.id;
    });

    if (this.contentHub.dataset.excludeids > 0) {
      exclusionIds.push(this.contentHub.dataset.excludeids);
    }
    window
      .fetch("/api/related/query?culture=" + this.contentHub.dataset.culture, {
        method: "POST",
        mode: "same-origin",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify({
            ContentTypes: !this.contentHub.dataset.contenttypes ? [] : this.contentHub.dataset.contenttypes.split(","),
            ResourceTypes: !this.contentHub.dataset.resource ? [] : this.contentHub.dataset.resource.split(","),
            Categories: !this.contentHub.dataset.category ? [] : this.contentHub.dataset.category.split(","),
            Sectors: !this.contentHub.dataset.sector ? [] : this.contentHub.dataset.sector.split(","),
            Services: !this.contentHub.dataset.service ? [] : this.contentHub.dataset.service.split(","),
            SortOrder:!this.contentHub.dataset.sortorder ? null : this.contentHub.dataset.sortorder,
            RootNode: this.contentHub.dataset.rootnode,
          Authors:
            this.contentHub.dataset.author &&
            this.contentHub.dataset.author !== "0" ? [this.contentHub.dataset.author] : [],
          ExcludedIds: exclusionIds,
          ResultAmount: this.contentHub.dataset.totalresults,
          IsUserQuery: this.contentHub.dataset.iscontenthub === "true",
          CultureFallback: this.contentHub.dataset.fallback === "true"
        }),
      })
      .then((response) => response.json())
      .then((data) => {
        let result = data;

        if (result.content && result.content.length) {
          let htmlStr = "";

          let alreadyRenderedFeatured = items.pop();

          let bylabel = this.contentHub.dataset.bylabel;
          let disableColour = this.contentHub.dataset.disablecolour === "true";
          let allowPromoted = this.contentHub.dataset.allowpromoted === "true";
          let addColWidth = this.contentHub.dataset.iscontenthub === "true";
          let isNextFeatured = false;

          for (var x = 0; x < result.content.length; x++) {
            let obj = result.content[x];
            obj.isPromoted = allowPromoted && obj.isPromoted;

            if (
              x == 0 &&
              alreadyRenderedFeatured.classList.contains("o-flex__col--8") &&
              obj.IsPromoted
            ) {
              alreadyRenderedFeatured.classList.add("next");
            }

            if (x + 1 < result.content.length) {
              isNextFeatured =
                allowPromoted && result.content[x + 1].isPromoted;
            }
            const aliasName = obj["alias"];
            if(aliasName.includes("research")){
              htmlStr +=  this.makeHTMLresearch(
                obj
              );
            }else{
              htmlStr +=  this.makeHTML(
                obj,
                bylabel,
                disableColour,
                isNextFeatured,
                addColWidth
              );
            }


            isNextFeatured = false;
          }

          const hubItemsContainer =
            document.getElementById("content-hub-items");
          const lastEl = hubItemsContainer.lastElementChild;

          document
            .getElementById("content-hub-items")
            .insertAdjacentHTML("beforeend", htmlStr);

          const focusable = lastEl.nextElementSibling.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          focusable[0].focus();
        }

        this.showMoreBtn.style.display = result.moreResultsAvailable ? "inline-block" : "none";
      })
      .catch((error) => {
        console.log("RC Error:", error);
      });
  }
}
